import React from "react";
import { Link } from "react-router-dom";

export default function LandingFooter() {
  return (
    <footer className="bg-[#FFFFFF] border-t border-[#E5E7E0] py-10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 flex flex-col gap-5">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <a href="/" className="inline-flex items-center" aria-label="Pronto" data-testid="footer-brand">
              <img
                src="/logo/mark-symbol.png?v=4"
                alt="Pronto"
                className="h-10 w-10 select-none"
                draggable="false"
              />
            </a>
            <div className="mt-2 text-xs text-[#6B6A65]">per agenti immobiliari · prontoimmo.it</div>
          </div>
          <div className="text-xs sm:text-right leading-relaxed">
            <div className="text-sm text-[#6B6A65]">© {new Date().getFullYear()} Prontoimmo · startup italiana con sede a Bergamo</div>
            <div className="mt-1 text-[#9A968B]">P.IVA 03868770169 · Bergamo, Italia</div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-[#6B6A65] pt-4 border-t border-[#E5E7E0]">
          <a href="/blog" className="hover:text-[#7C8B6E] font-medium" data-testid="footer-blog">Blog</a>
          <span>·</span>
          <a href="/pricing" className="hover:text-[#7C8B6E]" data-testid="footer-pricing">Prezzi</a>
          <span>·</span>
          <a href="/terms?tab=privacy" className="hover:text-[#7C8B6E]" data-testid="footer-privacy">Privacy Policy</a>
          <span>·</span>
          <a href="/terms?tab=cookie" className="hover:text-[#7C8B6E]" data-testid="footer-cookie">Cookie Policy</a>
          <span>·</span>
          <a href="/terms?tab=refund" className="hover:text-[#7C8B6E]" data-testid="footer-refund">Recesso e Rimborsi</a>
          <span>·</span>
          <a href="/terms?tab=general" className="hover:text-[#7C8B6E]" data-testid="footer-terms">Termini e Condizioni</a>
          <span>·</span>
          <a href="/terms?tab=demo" className="hover:text-[#7C8B6E]" data-testid="footer-demo-terms">Termini Demo</a>
          <span>·</span>
          {/* iter v29 r123 · Instagram link */}
          <a
            href="https://www.instagram.com/prontoimmo.it"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#7C8B6E] inline-flex items-center gap-1"
            data-testid="footer-instagram"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#7C8B6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
            @prontoimmo.it
          </a>
          <span className="ml-auto">
            <Link to="/contatti" className="underline hover:text-[#7C8B6E]" data-testid="footer-contatti">
              Contattaci
            </Link>
          </span>
        </div>
        {/* iter r95 · Riga compliance AI · Legge 132/2025 + AI Act UE */}
        <div className="pt-3 border-t border-[#E5E7E0]/70 text-[11px] text-[#9A968B] leading-relaxed">
          <span className="inline-flex items-center gap-1.5 mr-3">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#7C8B6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
            <span className="font-semibold text-[#6B6A65]">Servizio con AI generativa</span>
          </span>
          Conforme al Regolamento UE 2024/1689 (AI Act) e alla{" "}
          <a href="/terms?tab=general#ai" className="underline hover:text-[#7C8B6E]" data-testid="footer-ai-law">
            Legge italiana 23 settembre 2025 n. 132
          </a>{" "}
          in materia di intelligenza artificiale · trasparenza algoritmica e supervisione umana garantite.
        </div>
      </div>
    </footer>
  );
}
